import { X, AlertCircle } from "lucide-react";

const SUPPORT_EMAIL = "support@makeyourself.ai";

export function ErrorBanner({
  message,
  sessionId,
  context,
  onDismiss,
}: {
  message: string;
  sessionId: string | null;
  context?: string;
  onDismiss: () => void;
}) {
  const body = encodeURIComponent(
    `Issue: ${message}\nSession: ${sessionId ?? "none"}\nContext: ${context ?? "n/a"}\n\n[describe what you were doing]`,
  );
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=myai+Excel+issue&body=${body}`;

  return (
    <div
      role="alert"
      className="flex items-start gap-2 border-b border-[var(--status-error)]/30 bg-[var(--status-error)]/10 px-3 py-2 text-[13px]"
    >
      <AlertCircle
        size={14}
        strokeWidth={1.5}
        className="mt-0.5 shrink-0 text-[var(--status-error)]"
      />
      <div className="flex-1 text-[var(--text-secondary)]">
        <span>{message} </span>
        <a href={mailto} className="text-[var(--brand-accent)] hover:underline">
          Report this
        </a>
      </div>
      <button
        onClick={onDismiss}
        aria-label="Dismiss error"
        className="text-[var(--text-muted)] hover:text-[var(--text-primary)]"
      >
        <X size={14} strokeWidth={1.5} />
      </button>
    </div>
  );
}
